import { render, staticRenderFns } from "./OrderDetailMessenger.vue?vue&type=template&id=35a496d8&scoped=true"
import script from "./OrderDetailMessenger.vue?vue&type=script&lang=js"
export * from "./OrderDetailMessenger.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailMessenger.vue?vue&type=style&index=0&id=35a496d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a496d8",
  null
  
)

export default component.exports